import React from 'react';
import { useLanguage } from '../../context/language-context-provider';
const ProcessingStatistics = () => {
  const {
    t
  } = useLanguage();
  return <div className='flex flex-col items-center justify-center gap-6 py-5.5 lg:flex-row lg:py-6' data-sentry-component="ProcessingStatistics" data-sentry-source-file="processing.tsx">
            <div className='item'>
                <span className='title'>{t('statistics.processing.item1.title')}</span>
                <span className='value'>{t('statistics.processing.item1.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.processing.item2.title')}</span>
                <span className='value'>{t('statistics.processing.item2.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.processing.item3.title')}</span>
                <span className='value'>{t('statistics.processing.item3.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.processing.item4.title')}</span>
                <span className='value'>{t('statistics.processing.item4.text')}</span>
            </div>
        </div>;
};
export default ProcessingStatistics;